/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Crossstream1Inputs */

const id_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build ini berasal dari saluran rilis yang berbeda.`)
};

const ms_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan ini berasal daripada saluran keluaran yang berbeza.`)
};

const da_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disse builds kommer fra forskellige udgivelseskanaler.`)
};

const de_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Builds stammen aus unterschiedlichen Release-Kanälen.`)
};

const en_us2_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These builds come from different release channels.`)
};

const es_es2_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas compilaciones proceden de canales de lanzamiento distintos.`)
};

const es_mx2_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas compilaciones proceden de canales de lanzamiento distintos.`)
};

const fil_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga build na ito ay mula sa magkakaibang release channel.`)
};

const fr_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces builds proviennent de canaux de publication différents.`)
};

const it_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queste build provengono da canali di rilascio diversi.`)
};

const hu_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ezek a buildek különböző kiadási csatornákból származnak.`)
};

const nl_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze builds komen uit verschillende releasekanalen.`)
};

const no_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disse buildene kommer fra ulike utgivelseskanaler.`)
};

const pl_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te buildy pochodzą z różnych kanałów wydań.`)
};

const pt_br2_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses builds vêm de canais de lançamento diferentes.`)
};

const pt_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas compilações provêm de canais de lançamento diferentes.`)
};

const ro_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceste builduri provin din canale de lansare diferite.`)
};

const fi_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nämä buildit ovat peräisin eri julkaisukanavista.`)
};

const sv_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De här buildsen kommer från olika utgivningskanaler.`)
};

const vi_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các build này đến từ những kênh phát hành khác nhau.`)
};

const tr_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu derlemeler farklı yayın kanallarından geliyor.`)
};

const cs_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyto buildy pocházejí z různých kanálů vydání.`)
};

const bg_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тези компилации идват от различни канали за издаване.`)
};

const ru_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эти сборки относятся к разным каналам выпуска.`)
};

const uk_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ці білди походять із різних каналів випуску.`)
};

const ar_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأتي هذه البناءات من قنوات إصدار مختلفة.`)
};

const hi_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ये बिल्ड अलग-अलग रिलीज़ चैनल से आते हैं।`)
};

const th_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์เหล่านี้มาจากช่องทางการเผยแพร่ที่แตกต่างกัน`)
};

const ja_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これらのビルドは異なるリリースチャンネルのものです。`)
};

const zh_cn2_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些构建来自不同的发布渠道。`)
};

const zh_hant1_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這些組建來自不同的發行頻道。`)
};

const ko_builds_comparison_crossstream1 = /** @type {(inputs: Builds_Comparison_Crossstream1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 빌드들은 서로 다른 릴리스 채널에서 가져왔습니다.`)
};

/**
* | output |
* | --- |
* | "These builds come from different release channels." |
*
* @param {Builds_Comparison_Crossstream1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_crossstream1 = /** @type {((inputs?: Builds_Comparison_Crossstream1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Crossstream1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_crossstream1(inputs)
	if (locale === "ms") return ms_builds_comparison_crossstream1(inputs)
	if (locale === "da") return da_builds_comparison_crossstream1(inputs)
	if (locale === "de") return de_builds_comparison_crossstream1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_crossstream1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_crossstream1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_crossstream1(inputs)
	if (locale === "fil") return fil_builds_comparison_crossstream1(inputs)
	if (locale === "fr") return fr_builds_comparison_crossstream1(inputs)
	if (locale === "it") return it_builds_comparison_crossstream1(inputs)
	if (locale === "hu") return hu_builds_comparison_crossstream1(inputs)
	if (locale === "nl") return nl_builds_comparison_crossstream1(inputs)
	if (locale === "no") return no_builds_comparison_crossstream1(inputs)
	if (locale === "pl") return pl_builds_comparison_crossstream1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_crossstream1(inputs)
	if (locale === "pt") return pt_builds_comparison_crossstream1(inputs)
	if (locale === "ro") return ro_builds_comparison_crossstream1(inputs)
	if (locale === "fi") return fi_builds_comparison_crossstream1(inputs)
	if (locale === "sv") return sv_builds_comparison_crossstream1(inputs)
	if (locale === "vi") return vi_builds_comparison_crossstream1(inputs)
	if (locale === "tr") return tr_builds_comparison_crossstream1(inputs)
	if (locale === "cs") return cs_builds_comparison_crossstream1(inputs)
	if (locale === "bg") return bg_builds_comparison_crossstream1(inputs)
	if (locale === "ru") return ru_builds_comparison_crossstream1(inputs)
	if (locale === "uk") return uk_builds_comparison_crossstream1(inputs)
	if (locale === "ar") return ar_builds_comparison_crossstream1(inputs)
	if (locale === "hi") return hi_builds_comparison_crossstream1(inputs)
	if (locale === "th") return th_builds_comparison_crossstream1(inputs)
	if (locale === "ja") return ja_builds_comparison_crossstream1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_crossstream1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_crossstream1(inputs)
	return ko_builds_comparison_crossstream1(inputs)
});
export { builds_comparison_crossstream1 as "builds.comparison.crossStream" }